import script from "./TeamsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamsView.vue?vue&type=script&lang=ts&setup=true"

import "./TeamsView.vue?vue&type=style&index=0&id=058c784c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-058c784c"]])

export default __exports__